<div class="d-flex justify-content-center align-items-center my-1" style="font-size: 0.74375rem">
  <strong>{{baseImage?.type}}</strong>: {{baseImage?.label}}
  <i class="fa-light fa-arrow-right mx-2"></i>
  <strong>{{overlayImage?.type}}</strong>: {{overlayImage?.label}}
</div>
<ngb-progressbar type="info"
                 [value]="alpha * 100"
                 [animated]="true"
                 style="height: 2px;"
                 class="mb-2">
</ngb-progressbar>
